import {createRoot} from 'react-dom/client'
import ErrorBoundary from '../common/components/ErrorBoundary.js'
import Tracking from './Tracking.js'
import {StoreProvider} from '../ztore.js'

document.querySelector('body').classList.add('tracking-page')
const root = createRoot(document.querySelector('#root'))

root.render(
  <ErrorBoundary>
    <StoreProvider>
      <Tracking />
    </StoreProvider>
  </ErrorBoundary>,
)
